import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { PropTypes } from 'prop-types';
import {
  FormControl,
  Divider,
  Box,
  CardContent,
  Grid,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import FeedIcon from '@mui/icons-material/Feed';
import Switch from '@mui/material/Switch';
import {
  FieldPhone,
  FieldEmail,
  FieldText,
  FieldtextArea,
  FieldNumber,
  FieldList,
  FieldFile,
  FieldDateTime,
  FieldListImputIncrement,
  FieldNumberId,
  FieldListSearch,
} from './fields';
import entity from './fields/entity';

function CreateForms({
  fields,
  getFields,
  getEnabledForm,
  idGroupShow,
  sxfields,
  dataDefauld
}) {
  const [tiposCampos] = useState({
    grupo: 'grupo',
    text: 'text',
    textarea: 'textarea',
    list: 'list',
    file: 'file',
    phone: 'phone',
    email: 'email',
    number: 'number',
    date: 'date',
    time: 'time',
    rangeDate: 'rangeDate',
    rangeTime: 'rangeTime',
    listInput: 'listInput',
    float: 'float',
    numberId: 'numberId',
    fieldListSearch: 'fieldListSearch',
  });

  const [formulario, setFormulario] = useState([]);
  const [flafInvalidFormat, setFlafInvalidFormat] = useState(false);

  const [customizeFields, setCustomizeFields] = useState({
    HelperText: { size: 10, color: '#c84d4d' },
  });

  //const libraryField = useSelector((store) => store.bazooit.dataForms);

  useEffect(() => {
    setFormulario(JSON.parse(JSON.stringify(fields)));
  }, []);

  useEffect(() => {
    if (dataDefauld) {
      fields.map((F) => F.groups.map(G => G.fields.map(F => {
        if(dataDefauld[G.id]!==undefined) {
            F.value = dataDefauld[G.id][F.id]
            if(G.optional && dataDefauld[G.id][F.id] !== undefined) { G.optionalHideDefauld = false}
        }
      })))
      console.log(fields)
      setFormulario(JSON.parse(JSON.stringify(fields)))
    }
  }, [dataDefauld]);


  const validateForm = () => {
    if (getEnabledForm) {
      let enable = true;
      if (formulario.length > 0) {

        formulario.map(f => f.groups.map((g) => {
          if ((g.display && g.optional === undefined) || g.optionalHideDefauld === false) {
            g.fields.map((f) => {
              if (f.value === entity.INVALID_FORMAT) {
                enable = false;
              }

              if (!f.display && f.required && (f.value === '' || f.value === undefined || f.value === null)) {
                enable = false;
              }
            })
          }
        }))
      }
      getEnabledForm(enable);
    }

  };

  useEffect(() => {
    getFields(formulario);
    validateForm();
    //console.log(JSON.stringify(formulario,null,2))
  }, [formulario]);

  const findDependence = (index, newValue, indexGroup, indexFormulario) => {
    const fielSelect = formulario[indexFormulario].groups[indexGroup].fields[index].id
    const fielValueSelect = formulario[indexFormulario].groups[indexGroup].fields[index].value
    formulario.map(f => f.groups.map((f,findex) => f.fields.map(field => {
      if (field.showCondition && field.showCondition.field === fielSelect) {
        if(findex===indexGroup){
          if (field.showCondition.field === fielSelect && field.showCondition.value === fielValueSelect) {
          field.display = false
        } else {
          field.display = true
          delete field.value
        }
        }
        
      }
    }
    )))
  }

  const updateGroup = (itemGroup, indexGroup, indexFormulario, idGrupo) => {
    const newGroups = [...formulario];
    const newValue = !newGroups[indexFormulario].groups[indexGroup].optionalHideDefauld
    newGroups[indexFormulario].groups[indexGroup].optionalHideDefauld = newValue;
    //findDependence(index, newValue, indexGroup, indexFormulario)
    setFormulario(newGroups);
  };

  const updateFields = (index, newValue, indexGroup, indexFormulario) => {
    const newGroups = [...formulario];
    newGroups[indexFormulario].groups[indexGroup].fields[index].value = newValue;
    findDependence(index, newValue, indexGroup, indexFormulario)
    setFormulario(newGroups);
  };


  const handleUpload = (index, newValue, indexGroup, indexFormulario) => {
    const newGroups = [...formulario];
    const file = newValue.target.files[0];
    newGroups[indexFormulario].groups[indexGroup].fields[index].value = file === undefined ? '' : newValue;
    newGroups[indexFormulario].groups[indexGroup].fields[index].file = file;
    findDependence(index, newValue, indexGroup, indexFormulario)
    setFormulario(newGroups);
  };

  const buildFields = (fieldGroup, indexGroup, indexFormulario, idGrupo, groupTitle) => {
    /*  dataDefauld &&  fieldGroup.map((field) => {
       dataDefauld.map(group => console.log(group[field]) )
     }) */
    const fieldsLocal = fieldGroup.map((field, indexField) => (!field.display  || !field.showCondition) ? (

      <Grid
        item
        key={field.id}
        {...field.size}
      >
        {/* CAMPO TEXTO */}
        {field.kind === tiposCampos.text && (
          <FieldText
            field={field}
            onChange={updateFields}
            indexField={indexField}
            indexGroup={indexGroup}
            indexFormulario={indexFormulario}
            customize={customizeFields}
            sx={sxfields}
          />
        )}
        {/* CAMPO AREA DE TEXTO */}
        {field.kind === tiposCampos.textarea && (
          <FieldtextArea
            field={field}
            onChange={updateFields}
            indexField={indexField}
            indexGroup={indexGroup}
            indexFormulario={indexFormulario}
            customize={customizeFields}
            sx={sxfields}
          />
        )}
        {/* CAMPO DE LISTA */}
        {field.kind === tiposCampos.list && (
          <FieldList
            field={field}
            onChange={updateFields}
            indexField={indexField}
            indexGroup={indexGroup}
            indexFormulario={indexFormulario}
            customize={customizeFields}
            sx={sxfields}
          />
        )}
        {/* CAMPO FILE */}

        {field.kind === tiposCampos.file && (
          <FieldFile
            field={field}
            onChange={handleUpload}
            indexField={indexField}
            indexGroup={indexGroup}
            indexFormulario={indexFormulario}
            customize={customizeFields}
            sx={sxfields}
          />

        )}
        {/* CAMPO phone */}
        {field.kind === tiposCampos.phone && (
          <FieldPhone
            field={field}
            onChange={updateFields}
            indexField={indexField}
            indexGroup={indexGroup}
            indexFormulario={indexFormulario}
            customize={customizeFields}
            sx={sxfields}
          />
        )}
        {/* CAMPO email */}
        {field.kind === tiposCampos.email && (
          <FieldEmail
            field={field}
            onChange={updateFields}
            indexField={indexField}
            indexGroup={indexGroup}
            indexFormulario={indexFormulario}
            customize={customizeFields}
            sx={sxfields}
          />
        )}
        {/* CAMPO NUMERO */}
        {(field.kind === tiposCampos.number || field.kind === tiposCampos.float) && (
          <FieldNumber
            field={field}
            onChange={updateFields}
            indexField={indexField}
            indexGroup={indexGroup}
            indexFormulario={indexFormulario}
            customize={customizeFields}
            sx={sxfields}
          />
        )}
        {/* DATE */}
        {field.kind === tiposCampos.date && (
          <FieldDateTime
            field={field}
            onChange={updateFields}
            indexField={indexField}
            indexGroup={indexGroup}
            indexFormulario={indexFormulario}
            customize={customizeFields}
            sx={sxfields}
          />
        )}
        {/* FIEDS LIST IMPUT */}
        {field.kind === tiposCampos.listInput && (
          <FieldListImputIncrement
            field={field}
            onChange={updateFields}
            indexField={indexField}
            indexGroup={indexGroup}
            indexFormulario={indexFormulario}
            customize={customizeFields}
            sx={sxfields}
          />
        )}
        {/* CAMPO numberId */}
        {field.kind === tiposCampos.numberId && (
          <FieldNumberId
            field={field}
            onChange={updateFields}
            indexField={indexField}
            indexGroup={indexGroup}
            indexFormulario={indexFormulario}
            customize={customizeFields}
            sx={sxfields}
          />
        )}
        {/* CAMPO DE LISTA SAERCH */}
        {field.kind === tiposCampos.fieldListSearch && (
          <FieldListSearch
            field={field}
            onChange={updateFields}
            indexField={indexField}
            indexGroup={indexGroup}
            indexFormulario={indexFormulario}
            customize={customizeFields}
            sx={sxfields}
          />
        )}

      </Grid>
    ):<></>);

    console.log(fieldsLocal)

    return fieldsLocal;
  };

  const fieldForm = (itemGroup, indexGroup, indexFormulario, idGrupo) => {
    const field = (

      <Grid
        key={idGrupo}
        {...itemGroup.size}
        sx={{ pl: 0, pr: 0, pt: 0, }}
      >
        {itemGroup.title && (
          <Typography
            sx={{
              pt: 0, pb: 0, pl: 2, pr: 2, mb: 0,
            }}
            variant="h6"
            component="p"
          >
            <FeedIcon sx={{ mb: -0.8 }} />
            {' '}
            {itemGroup.title}
            {itemGroup.optional && <Switch onClick={() => updateGroup(itemGroup, indexGroup, indexFormulario, idGrupo)} checked={!itemGroup.optionalHideDefauld} size="small" />}
          </Typography>
        )}
        <Typography variant="p" component="p">
          <Box sx={{
            mb: 0, mt: 0, pt: itemGroup.title ? 1 : 0, pb: 0,
          }}
          >
            <FormControl fullWidth size="small">
              <CardContent sx={{
                m: 0, pl: 2, pr: 2, pb: 0, pt: 0,
              }}
              >
                <Grid

                >
                  <Grid container spacing={1}>
                    {!itemGroup.optionalHideDefauld && buildFields(itemGroup.fields, indexGroup, indexFormulario, idGrupo, itemGroup.title)}
                  </Grid>
                </Grid>

              </CardContent>
            </FormControl>
          </Box>
        </Typography>
      </Grid>

    );

    return field;
  };

  return (
    <Grid container>
      {formulario.length > 0 && formulario.map((groupDates, indexFormulario) => (
        <>
          {idGroupShow === 0 ? (
            groupDates.initialFields && groupDates.groups.map((itemGroup, indexGroup) => (
              itemGroup.display && fieldForm(itemGroup, indexGroup, indexFormulario, groupDates.id)
            ))) : (groupDates.id === idGroupShow && groupDates.groups.map((itemGroup, indexGroup) => (
              itemGroup.display && fieldForm(itemGroup, indexGroup, indexFormulario, groupDates.id)
            )))
          }
        </>
      )
      )}

    </Grid>
  );
}

CreateForms.propTypes = {
  fields: PropTypes.objectOf.isRequired,
  getFields: PropTypes.func.isRequired,
  getEnabledForm: PropTypes.func.isRequired,
  loader: PropTypes.bool,
};

export default CreateForms;
